<template>
  <g fill-rule="evenodd">
    <path
      d="M17.94 10.38a.97.97 0 00.05-.51l-.02-.12a.95.95 0 00-.25-.46l-4-4a1 1 0 10-1.42 1.42L14.6 9H3a1 1 0 100 2h11.6l-2.3 2.3a1 1 0 001.42 1.4l4-4c.1-.09.16-.2.21-.3v-.02"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NextArrowIcon",
});
</script>
